import { render, staticRenderFns } from "./LevelsListEdit.vue?vue&type=template&id=646203c8&"
import script from "./LevelsListEdit.vue?vue&type=script&lang=js&"
export * from "./LevelsListEdit.vue?vue&type=script&lang=js&"
import style0 from "./LevelsListEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports